import { WithClassName } from '@/blocks/components/types';
import classNames from 'classnames';
import styles from './styles.module.scss';

type PieChartProps = {
  diameter: number;
  slices: number[];
} & WithClassName;

export function PieChart({ diameter = 200, className, ...props }: PieChartProps) {
  const radius = diameter / 2;
  const circumference = (Math.PI * 2 * radius) / 2;

  let offset = 0;

  const slices = (props.slices || [])
    .filter((i) => i > 0)
    .map((i, key) => {
      const sliceWidth = i * (circumference / 100);
      const slice = (
        <circle
          key={key}
          r={radius / 2}
          cx={radius}
          cy={radius}
          strokeWidth={radius}
          strokeDashoffset={offset}
          strokeDasharray={`${sliceWidth} ${circumference}`}
        />
      );
      offset -= sliceWidth;
      return slice;
    });

  return (
    <svg
      className={classNames(styles.pieChart, className)}
      height={diameter}
      width={diameter}
      viewBox={`0 0 ${diameter} ${diameter}`}
    >
      <circle className={styles.pieChartBgCircle} r={radius} cx={radius} cy={radius} />
      <g className={styles.pieChartSlicesContainer}>{slices}</g>
      <circle className={styles.pieChartHole} r={radius / 2} cx={radius} cy={radius} />
    </svg>
  );
}
